import React, { useState, useCallback, useEffect } from 'react';
import { GoChevronDown } from 'react-icons/go';
import { MdChat } from 'react-icons/md';
import { Card } from './styles';

const ModuleRow = React.memo(({ module, onClickModule, onClickCompareVersion, onClickDiscussion }) => (
    <div className="card-row">
        <div className="card-body" item={module.moduleID} onClick={onClickModule}>
            <div className="col-md-3">
                {module.cultureTypeID != null ? module.cultureTypeName : module.description}
            </div>
            <div className="col-md-2 last-change-column">
                {module.dateLastChange != null ? module.dateLastChange : ""}
            </div>
            <div className="col-md-2 year-version-column">
                {module.sentBy}
            </div>
            <div className="col-md-1 year-version-column" style={{ paddingLeft: '35px' }}>
            </div>
            <div className="col-md-2">
                <div className={
                    module.statusNumber === 0
                        ? "status notStarted"
                        : ((module.statusNumber === 3 || module.statusNumber === 5 || module.statusNumber === 8 || module.statusNumber === 9)
                            ? "status rejected"
                            : "status complete")
                }>
                    {module.status}
                </div>
            </div>
            <div className="col-md-1">
                {module.isFinalVersion != null ? (
                    <div className={!module.isFinalVersion ? "status pending" : "status complete"}>
                        {module.isFinalVersion ? "Final" : "Partial"}
                    </div>
                ) : null}
            </div>
            <div className="col-md-1">
                {/* <div className={module.percentage === 0 ? "status pending" : "status complete"}>
                    {`${module.percentage}%`}
                </div> */}
            </div>
        </div>
        <div className="card-row-buttons-body">
            <button
                title="Compare Versions"
                className="card-row-button version-button"
                onClick={onClickCompareVersion}
            >
                v{module.version}
            </button>
            <button
                title="Discussion Dashboard"
                className="card-row-button-last"
                onClick={onClickDiscussion}
            >
                <MdChat size={20} />
            </button>
        </div>
    </div>
));

ModuleRow.displayName = 'ModuleRow';

const OperationsList = React.memo(({ 
    data, 
    userObject,
    onModuleClick, 
    onCompareVersion, 
    onDiscussionClick 
}) => {
    const [selectedAccordionOperation, setSelectedAccordionOperation] = useState(null);

    // Abrir o primeiro form automaticamente quando os dados carregarem
    useEffect(() => {
        if (data && data.length > 0) {
            setSelectedAccordionOperation(data[0].operationID);
        }
    }, [data]);

    const handleToggle = useCallback((operationID) => {
        setSelectedAccordionOperation(prev => prev === operationID ? null : operationID);
    }, []);

    const handleModuleClick = useCallback((operation, module) => () => {
        onModuleClick(operation.description, module);
    }, [onModuleClick]);

    const handleCompareVersion = useCallback((operation, module) => (e) => {
        e.stopPropagation();
        onCompareVersion(userObject.companyID, operation.reportYearID, operation.operationID, module.moduleID);
    }, [userObject, onCompareVersion]);

    const handleDiscussion = useCallback((operation, module) => (e) => {
        e.stopPropagation();
        onDiscussionClick(userObject.companyID, operation.reportYearID, operation.operationID, module.moduleID);
    }, [userObject, onDiscussionClick]);

    return (
        <>
            <div className="cards-header">
                <div className="col-md-3">Form</div>
                <div className="col-md-2 last-change-column" style={{ paddingRight: '55px' }}>Last change</div>
                <div className="col-md-2" style={{ paddingLeft: 32 }}>Sent by</div>
                <div className="col-md-1 year-version-column">Crop Year</div>
            </div>
            {data.map((operation) => (
                <Card className="show" key={operation.operationID} item={operation.operationID}>
                    <div 
                        className={`card-body ${selectedAccordionOperation === operation.operationID ? 'collapsed' : ''}`} 
                        onClick={() => handleToggle(operation.operationID)}
                    >
                        <div className="col-md-3">
                            <GoChevronDown />{operation.description}
                        </div>
                        <div className="col-md-2 last-change-column"></div>
                        <div className="col-md-2"></div>
                        <div className="col-md-1 year-version-column">
                            {operation.operationID !== 4 ? operation.year : ""}
                        </div>
                        <div className="col-md-2"></div>
                        <div className="col-md-1"></div>
                        <div className="col-md-1">
                            {/* <div className={operation.percentage === 0 ? "status pending" : "status complete"}>
                                {`${operation.percentage}%`}
                            </div> */}
                        </div>
                    </div>
                    <div className={`card collapse ${selectedAccordionOperation === operation.operationID ? 'show' : ''}`}>
                        {operation.modules && operation.modules.length > 0 ? (
                            operation.modules.map((module) => (
                                <ModuleRow
                                    key={module.moduleID}
                                    module={module}
                                    onClickModule={handleModuleClick(operation, module)}
                                    onClickCompareVersion={handleCompareVersion(operation, module)}
                                    onClickDiscussion={handleDiscussion(operation, module)}
                                />
                            ))
                        ) : (
                            <div className="no-record-found">
                                <div className="col-md-12">No records found</div>
                            </div>
                        )}
                    </div>
                </Card>
            ))}
        </>
    );
});

OperationsList.displayName = 'OperationsList';

export default OperationsList;

